import $ from 'jquery'
/**
 * Реэкспорт Jquery, чтобы работали плагины.
 */
window.$ = window.jQuery = $
export default $
